import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ImportantDates from "./components/ImportantDates";
import AboutConference from "./components/AboutConference";
import AboutInstitute from "./components/AboutInstitute";
import Tracks from "./components/Tracks";
import OrganizingCommittee from "./components/OrganizingCommittee";
import RegistrationFee from "./components/RegistrationFee";
import PeerReviewProcess from "./components/PeerReviewProcess";
import Footer from "./components/Footer";
import Chatbot from "./components/chatbot/ChatbotWidget"; // Importing the ChatbotWidget component
import "./styles/App.css";

function App() {
  return (
    <>
      <Navbar />
      <div className="App">
        <Chatbot />

        <Hero />
        <ImportantDates />
        <AboutInstitute />
        <AboutConference />
        <Tracks />
        <RegistrationFee />
        <OrganizingCommittee />

        <PeerReviewProcess />
        <Footer />
      </div>
    </>
  );
}

export default App;
